export const SITE_URL: string =
  (import.meta.env.VITE_SITE_URL as string | undefined) || "https://usfanslink.guru";

export const SITE_NAME = "USFansLink";

export const FAVICON_URL =
  "https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2277e9ffbdee9fd651886f1aeeba0d56.jpeg";

export function websiteJsonLd() {
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebSite",
        "@id": `${SITE_URL}/#website`,
        url: `${SITE_URL}/`,
        name: SITE_NAME,
        description:
          "Independent resource hub for the USFans Spreadsheet with product categories, reviews, shipping information, QC guides and safety checks.",
        inLanguage: ["en", "pl", "es", "fr"],
        publisher: { "@id": `${SITE_URL}/#organization` },
      },
      {
        "@type": "Organization",
        "@id": `${SITE_URL}/#organization`,
        name: SITE_NAME,
        url: `${SITE_URL}/`,
        logo: {
          "@type": "ImageObject",
          url: FAVICON_URL,
        },
      },
    ],
  };
}

interface ArticleSeoInput {
  title: string;
  description: string;
  path: string;
}

export function articleJsonLd({ title, description, path }: ArticleSeoInput) {
  const url = `${SITE_URL}${path}`;
  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Article",
        "@id": `${url}#article`,
        headline: title,
        description,
        author: {
          "@type": "Organization",
          name: "USFansLink Editorial Team",
          url: `${SITE_URL}/`,
        },
        publisher: { "@id": `${SITE_URL}/#organization` },
        datePublished: "2026-08-22",
        dateModified: "2026-08-22",
        mainEntityOfPage: { "@type": "WebPage", "@id": url },
        inLanguage: "en",
      },
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: `${SITE_URL}/` },
          { "@type": "ListItem", position: 2, name: title, item: url },
        ],
      },
    ],
  };
}

export function faqJsonLd(faqs: { question: string; answer: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((faq) => ({
      "@type": "Question",
      name: faq.question,
      acceptedAnswer: { "@type": "Answer", text: faq.answer },
    })),
  };
}